import Vue from 'vue'
import Router from 'vue-router'
import {iStorage} from 'smart-core-util'
import index from "../pages/index"
import editDemand from "../pages/editDemand"
import servicePersonList from "../pages/servicePersonList"
import confirmSettlement from "../pages/confirmSettlement"

Vue.use(Router)

/**
 * views 路由
 */
const supplierRouters = [
    {
        path: '/',
        name: 'index',
        component: index
    },
    {
        path: '/editDemand',
        name: 'editDemand',
        component: editDemand
    },
    {
        path: '/servicePersonList',
        name: 'servicePersonList',
        component: servicePersonList
    },
    {
        path: '/confirmSettlement',
        name: 'confirmSettlement',
        component: confirmSettlement
    },
]

const router = new Router({
    mode: 'history',
    routes: supplierRouters
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js